import Skill from '@components/Skill'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'

const StyledSkills = styled.div`
  --offset: 4rem;

  > * {
    &:not(:last-child) {
      margin-bottom: var(--offset);

      ${up('md')} {
        --offset: 20rem;
      }
    }
  }
`

const Skills = () => (
  <StyledSkills>
    <Skill
      imageSrc="images/skills/web-development.png"
      title="Web development"
      description="10 years in web development. We are not afraid of either backend- or frontendcentered projects. No matter the size of your product or service, we’re here to help. You can find below the service that will allow us to make your idea come true."
      projects={[
        {
          title: 'Front-end',
          description:
            'This is the side of the product that is visible to your clients. We rely on the well-known and trusted REACT and VUE frameworks, which make your website fast and functional.',
        },
        {
          title: 'Back-end',
          description:
            'This is the invisible part of the product. It doesn’t matter whether it’s a content management system or a complex business logic—we’ve done it all. Usually, backend work is carried out by employing the Symfony4 framework, but that is not to say it ought to stay this way.',
        },
      ]}
    />
    <Skill
      imageSrc="images/skills/e-commerce.png"
      title="E-commerce"
      description="Become independent of the big brands. Nowadays, the internet has become the go-to platform for shopping. Give your customers the option to purchase your products through a professional online store!"
      projects={[
        {
          title: 'Prestashop',
          description:
            'As one of the most popular systems, Prestashop is more than enough for small or medium-sized stores. Dozens of add-ons and a global community make it simple to get your online store up and running.',
        },
        {
          title: 'Sylius',
          description:
            'This is an ideal solution for advanced e-commerce systems where stability, high efficiency, and scalability are key.',
        },
        {
          title: 'Custom Solutions',
          description:
            'Are you in need of a tailor-made solution? Say no more! We take pride in designing and developing complex and capacious platforms connected to applications and external systems.',
        },
      ]}
    />
    <Skill
      imageSrc="images/skills/mobile-development.png"
      title="Mobile development"
      description="Web users’ activity mainly comes from smartphones. Even the largest brands generate most of their revenue through mobile apps. Make use of this potential and become one of them!"
      projects={[
        {
          title: 'Cross-platform - Android & iOS',
          description:
            'We employ new tools that allow us to develop apps for both mobile platforms. That’s how we were able to accelerate the software development process by about 20%–30%. As a result, we are able to devote additional time to applying changes and developing new functions. Thanks to React Native and Flutter, and by using fewer resources, your mobile app will appear faster on Google Play and App Store.',
        },
      ]}
    />
    <Skill
      imageSrc="images/skills/product-design.png"
      title="Product design"
      description="By combining the best UI & UX practices and the latest solutions, we can create exciting digital products that meet expectations and the needs of your target group."
      projects={[
        {
          title: 'Design Sprint',
          description:
            'This is nothing more than a series of workshops popularized by Google that help us deal with the most important processes and elements of your product. It’s a tool used to enhance problem-solving, developing, and testing abilities.',
        },
        {
          title: 'UX Design',
          description:
            'Thanks to mock-ups, we are able to quickly check and test our ideas and solutions on the go. Additionally, it allows us to prepare the content hierarchy and to design complex functionalities. This way, we can accelerate the work at subsequent stages of development.',
        },
        {
          title: 'Design',
          description:
            'Our solutions are intuitive, tailored to your target group, and designed to meet your business goals. To do so, we use human-centered design. Nonetheless, we don’t shy away from the latest trends.',
        },
      ]}
    />
    <Skill
      imageSrc="images/skills/tech-partnership.png"
      title="Tech partnership"
      description=""
      projects={[
        {
          title: 'Maintenance',
          description:
            'Each of our products is built with scalability and future expansion in mind. We use solutions that make this task easier for us—CI/CD or automatic testing, for instance. We can also take care of your finalized app.',
        },
        {
          title: 'Body Leasing',
          description:
            'Are you in need of a team to build your product from the ground up? Our experienced developers are more than happy to make your dreams come true. Contact us to find out more!',
        },
      ]}
    />
  </StyledSkills>
)

export default Skills
